import API from './settings'

export const filterSites = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/site/filter`, formData);
};

export const getSite = (project_code: string, site_code: string): any => {
    return API.get(`/${project_code}/site/get/${site_code}`);
};

export const createSite = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/site/create`, formData);
};

export const editSite = (project_code: string, site_code: string, formData: any): any => {
    return API.post(`/${project_code}/site/edit/${site_code}`, formData);
}

export const deleteSite = (project_code: string, site_code: string): any => {
    return API.post(`/${project_code}/site/delete/${site_code}`);
};